var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer-board"},_vm._l((_vm.answerList),function(item,index){return _c('vue-drag-resize',{key:index,staticClass:"answer-font",attrs:{"x":20 + (index % 4) * 300,"y":Math.floor(index / 4) * 100 + 100,"w":260,"h":40,"isResizable":true,"isActive":false}},[_vm._v(_vm._s(item)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }